import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

export function useDebouncedUrlQuery(paramName = "q", delayMs = 400) {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialValue = searchParams.get(paramName) || "";
  const [draft, setDraft] = useState(initialValue);
  const [query, setQuery] = useState(initialValue.trim());
  const paramsRef = useRef(searchParams);
  const didMountRef = useRef(false);

  useEffect(() => {
    paramsRef.current = searchParams;
  }, [searchParams]);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    const timer = window.setTimeout(() => {
      const nextQuery = draft.trim();
      const nextParams = new URLSearchParams(paramsRef.current);

      if (nextQuery) {
        nextParams.set(paramName, nextQuery);
      } else {
        nextParams.delete(paramName);
      }

      setQuery(nextQuery);
      setSearchParams(nextParams, { replace: true });
    }, delayMs);

    return () => window.clearTimeout(timer);
  }, [delayMs, draft, paramName, setSearchParams]);

  return [draft, setDraft, query] as const;
}
